module.exports = __webpack_public_path__ + "static/media/epark-pin.f9db9dab.svg";